import { NgModule } from '@angular/core';
import { SafePipe } from './safe.pipe';
import { MarketTypeSinglePipe, MarketTypePluralPipe } from './market-type.pipe';

@NgModule({
    declarations: [ SafePipe, MarketTypeSinglePipe, MarketTypePluralPipe ],
    exports: [ SafePipe, MarketTypeSinglePipe, MarketTypePluralPipe ],
})
export class StockPipesModule {}
